import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const FlexibleWorkingPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  transportManagerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Flexible_Working_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Flexible Working Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} recognises the importance of work-life balance and is committed to supporting flexible working arrangements that meet both business needs and employee wellbeing.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, including drivers and operational staff, and covers flexible working requests, arrangements, and compliance with relevant working time legislation.
      </p>

      <h4 className="section-title">3. Flexible Working Arrangements</h4>
      <p className="section-content">
        Employees may request changes to their working hours, patterns, or locations. All requests will be considered fairly and in accordance with business operational requirements.
      </p>

      <h4 className="section-title">4. Working Time Regulations and Opt-Out Agreement</h4>
      <p className="section-content">
        Under the UK Working Time Regulations, the standard maximum working week is 48 hours averaged over 17 weeks. However, employees (including drivers) may voluntarily agree to opt out of this limit by signing an <strong>Opt-Out Agreement</strong>. This allows them to work longer hours, including overtime, subject to the following:
      </p>
      <ul>
        <li>The opt-out agreement must be voluntary and in writing.</li>
        <li>Employees can revoke the agreement with at least 7 days’ notice.</li>
        <li>Employers must keep a copy of the signed agreement.</li>
        <li>Working hours must still comply with other health and safety provisions.</li>
      </ul>

      <h4 className="section-title">5. Applying for Flexible Working</h4>
      <p className="section-content">
        Employees should submit flexible working requests in writing to their line manager or HR. Requests will be reviewed promptly and employees informed of decisions within a reasonable timeframe.
      </p>

      <h4 className="section-title">6. Record Keeping</h4>
      <p className="section-content">
        All flexible working arrangements and opt-out agreements will be documented and stored securely in employee records.
      </p>

      <h4 className="section-title">7. Health and Safety</h4>
      <p className="section-content">
        The company is committed to ensuring that flexible working arrangements do not compromise employee health and safety.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>Human Resources:</strong> {hrContact || "[Insert Contact Number]"}</li>
        <li><strong>Transport Manager:</strong> {transportManagerContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Opt-Out Agreement — Driver and Manager Signatures</h4>
      <p>
        I, _____________________________________ (employee name), voluntarily agree to opt out of the 48-hour weekly working time limit as set out in the Working Time Regulations. I understand that I may revoke this agreement by giving at least 7 days' written notice to my employer.
      </p>

      <div className="signature-section" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
        <div style={{ width: '45%' }}>
          <p><strong>Employee Signature:</strong> _________________________</p>
          <p><strong>Date:</strong> _________________________</p>
        </div>
        <div style={{ width: '45%' }}>
          <p><strong>Manager Signature:</strong> _________________________</p>
          <p><strong>Date:</strong> _________________________</p>
        </div>
      </div>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read and understood the Flexible Working Policy and agree to its terms.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy and any opt-out agreements have been approved by senior management and are now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default FlexibleWorkingPolicy;
